export const MedicalDept = {
  DENT: "DENT",
  DERM: "DERM",
  PS: "PS",
  OS: "OS",
  OPH: "OPH",
  KM: "KM",
  NS: "NS",
  CS: "CS",
  COMMON: "COMMON",
  VET_COMMON: "VET_COMMON",
};

export const MedicalDeptText = {
  DENT: "치과",
  DERM: "피부과",
  PS: "성형외과",
  OS: "정형외과",
  OPH: "안과",
  KM: "한의원",
  NS: "신경외과",
  CS: "흉부외과",
  COMMON: "공통",
  VET_COMMON: "수의과",
};

export function convertMedicalDept(value) {
  return MedicalDeptText[value] || "";
}

export const devices = {
  IOS: "iOS",
  AOS: "안드로이드",
  ETC: "기타",
};

export const appTypes = {
  CUSTOMER: "환자",
  HOSPITAL: "병원",
  MANUFACTURER: "제조사",
};
export const ServiceTypeEnum = {
  CUSTOMER: {
    code: "CUSTOMER",
    name: "환자",
  },
  HOSPITAL: {
    code: "HOSPITAL",
    name: "병원",
  },
  MANUFACTURER: {
    code: "MANUFACTURER",
    name: "제조사",
  },
  OPERATION: {
    code: "OPERATION",
    name: "운영",
  },
  STUDIO: {
    code: "STUDIO",
    name: "스튜디오",
  },
  WEBCHAT: {
    code: "WEBCHAT",
    name: "웹채팅",
  },
  RESELLER: {
    code: "RESELLER",
    name: "리셀러",
  },
};

export const GenderEnum = {
  MALE: "M",
  FEMALE: "F",
};

export const YnEnum = {
  Y: "Y",
  N: "N",
};

export const WarrantyStatusEnum = {
  ISSUED: "issued", // 지갑 저장됨
  WECHAT_ISSUED: "wechat-issued", // 위챗 전송됨
  SEND_BIZ: "send-biz", // 카톡 전송됨
  SEND_LMS: "send-lms", // 문자 전송됨
  BIZ_SEND_ERROR: "biz_send_error", // 발송 실패
  RETURNED: "returned", // 회수됨
  DISPOSED: "disposed", // 삭제됨
};

export const OphSurgeryPart = {
  LEFT: "좌안",
  RIGHT: "우안",
};

export const OphCompanies = {
  zeiss: {
    name: "ZEISS",
    imgUrl: "",
    colorCode: "#D8DCF3",
  },
};

export const ProductTypeEnum = {
  IMPLANT: "임플란트",
};

export const NftTitleEnum = {
  DENTIUM: "덴티움 정품 인증서",
  PLASMAPP: "플라즈맵 정품 표면처리 인증서",
  ZEISS: "자이스 코리아", // 해야 됨
  PS_HOSPITAL: "수술 책임관리 인증서",
  PS_CERTIFIED: "정품 보형물 인증서",
  PS_NOTCERTIFIED: "보형물 시술 확인서",
  ETC: "임플란트 제품 확인서",
};

export const KlipCompanyNameEnum = {
  DENTIUM: "덴티움(Dentium)",
  PLASMAPP: "플라즈맵(Plasmapp)",
  ZEISS: "자이스 코리아",
  SUNMEDICAL: "썬메디칼(Sun Medical)",
};

export const InformTextEnum = {
  DEFAULT: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
  ZEISS: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
};

export const TraitTypeEnum = {
  COMMON: {
    DEPT: "진료 과목",
    PRODUCTTYPE: "수술/시술 구분",
    HOSPITALNAME: "병원명",
    SURGERYDATE: "수술일",
    DOCTORNAME: "수술 의사",
    COMPANYNAME: "제조사",
    INFORMTEXT: "안내사항",
    ISSUEDBY: "발행주체",
    PRODUCTNAME: "제품명",
    SPEC: "제품 사양",
  },
  DENT: {
    TOOTHNO: "치아 번호",
  },
  OPH: {},
  PS: {
    IMPLANT_COMPANY: "보형물 제조사",
    IMPLANT_NAME: "보형물 제품명",
    IMPLANT_SPEC: "보형물 사양",
    IMPLANT_NO: "보형물 정품인증번호",
    LEFT_COMPANY: "보형물(L) 제조사",
    RIGHT_COMPANY: "보형물(R) 제조사",
    LEFT_NAME: "보형물(L) 제품명",
    RIGHT_NAME: "보형물(R) 제품명",
    LEFTSPEC: "보형물(L) 제품 사양",
    RIGHTSPEC: "보형물(R) 제품 사양",
    LEFTNO: "보형물(L) 정품인증번호",
    RIGHTNO: "보형물(R) 정품인증번호",
    NO: "보형물 정품인증번호",
  },
};

export const IssueMethodEnum = {
  SINGLE: {
    type: "single",
    text: "단건",
    fontColor: "",
    backgroundColor: "#E1F0FF",
  },
  BULK: {
    type: "bulk",
    text: "대량",
    fontColor: "#EB9400",
    backgroundColor: "#FFF1AD",
  },
};

export const WarrantyStatusText = {
  ISSUED: "지갑 저장됨", // ISSUED
  SEND_BIZ: "카톡 전송됨", // SEND_BIZ //
  SEND_LMS: "문자 전송됨", // SEND_LMS //
  BIZ_SEND_ERROR: "발송 실패", // BIZ_SEND_ERROR
  RETURNED: "회수됨", // RETURNED
  DISPOSED: "삭제됨", // DISPOSED
};

export const WarrantyImgUrlEnum = {
  DISPOSED:
    "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/nft_card/disposed.png",
  RETURNED:
    "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/nft_card/returned.png",
};

export function convertWarrantyStatus(value) {
  return WarrantyStatusText[value] || "-";
}

export const BuildModeEnum = {
  PROD: "production",
  STG: "stage",
  DEV: "development",
  LOCAL: "local",
};

export const enums = () => {
  return {
    WarrantyStatusEnum: {
      REQUEST_ISSUED: "request-issued", // 발행 요청됨
      ISSUED: "issued", // 지갑 저장됨
      DISPOSED: "disposed", // 삭제됨
      RETURNED: "returned", // 회수됨
      BIZ_SEND_ERROR: "biz_send_error", // 발송 실패
      SEND_LMS: "send-lms", // 문자 전송됨
      SEND_BIZ: "send-biz", // 카톡 전송됨
      WECHAT_ISSUED: "wechat-issued", // 위챗 전송됨
    },
    WarrantyStatusText: {
      ISSUED: "지갑 저장됨", // ISSUED
      DISPOSED: "삭제됨", // DISPOSED
      RETURNED: "회수됨", // RETURNED
      BIZ_SEND_ERROR: "발송 실패", // BIZ_SEND_ERROR
      SEND_LMS: "문자 전송됨", // SEND_LMS //
      SEND_BIZ: "카톡 전송됨", // SEND_BIZ //
    },
    NftTitleEnum: {
      DENTIUM: "덴티움 정품 인증서",
      PLASMAPP: "플라즈맵 정품 표면처리 인증서",
      ZEISS: "자이스 코리아", // 해야 됨
      PS_HOSPITAL: "수술 책임관리 인증서",
      PS_CERTIFIED: "정품 보형물 인증서",
      PS_NOTCERTIFIED: "보형물 시술 확인서",
      ETC: "임플란트 제품 확인서",
    },
    KlipCompanyNameEnum: {
      DENTIUM: "덴티움(Dentium)",
      PLASMAPP: "플라즈맵(Plasmapp)",
      ZEISS: "자이스 코리아",
      SUNMEDICAL: "썬메디칼(Sun Medical)",
    },
    InformTextEnum: {
      DEFAULT: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
      ZEISS: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
    },
    TraitTypeEnum: {
      COMMON: {
        DEPT: "진료 과목",
        PRODUCTTYPE: "수술/시술 구분",
        HOSPITALNAME: "병원명",
        SURGERYDATE: "수술일",
        DOCTORNAME: "수술 의사",
        COMPANYNAME: "제조사",
        INFORMTEXT: "안내사항",
        ISSUEDBY: "발행주체",
        PRODUCTNAME: "제품명",
        SPEC: "제품 사양",
      },
      DENT: {
        TOOTHNO: "치아 번호",
      },
      OPH: {},
      PS: {
        IMPLANT_COMPANY: "보형물 제조사",
        IMPLANT_NAME: "보형물 제품명",
        IMPLANT_SPEC: "보형물 사양",
        IMPLANT_NO: "보형물 정품인증번호",
        LEFT_COMPANY: "보형물(L) 제조사",
        RIGHT_COMPANY: "보형물(R) 제조사",
        LEFT_NAME: "보형물(L) 제품명",
        RIGHT_NAME: "보형물(R) 제품명",
        LEFTSPEC: "보형물(L) 제품 사양",
        RIGHTSPEC: "보형물(R) 제품 사양",
        LEFTNO: "보형물(L) 정품인증번호",
        RIGHTNO: "보형물(R) 정품인증번호",
        NO: "보형물 정품인증번호",
      },
    },
    ROLES: {
      HOSPITAL: {
        key: "HOSPIAL",
        label: "병원",
      },
      MANUFACTURER: {
        key: "MANUFACTURER",
        label: "제조사",
      },
      CERTILIFE: {
        key: "CERTILIFE",
        label: "운영",
      },
      CUSTOMER: {
        key: "CUSTOMER",
        label: "환자",
      },
    },
  };
};

export default enums;
